const lang = {
  cn: {
    // 操作按钮
    operateButton: {
      createProject: '创建项目',
      upload: '上传',
      uploadFile: '上传文件',
      restore: '还原',
      deleteThoroughly: '彻底删除',
      clear: '清空回收站',
      copyToCompanySpace: '复制到共享空间',
      move: '移动到',
      delete: '删除',
      download: '下载',
      refresh: '刷新',
      addFolder: '新建文件夹'
    },
    // 项目库
    project: {},
    // 员工/个人空间/共享空间
    space: {
      search: {
        placeholder: '请输入名称'
      },
      sort: '排序',
      projectName: '工程名称',
      breadcrumb: {
        root: '全部文件'
      },
      selectAll: '全选',
      column: {
        name: '名称',
        modifyTime: '修改时间',
        createTime: '创建时间',
        size: '文件大小',
        operate: '操作'
      },
      operateButton: {
        previewModel: '查看模型',
        preview: '预览',
        share: '分享',
        previewImage: '图片浏览'
      },
      tooltip: {
        user: '编制人',
        fileType: '文件类型',
        budget: '概算',
        estimate: '预算',
        settlement: '结算',
        reviewed: '审核',
        other: '其它',
        engineering: '工程类别',
        construct: '结构类别',
        item: '清单规则',
        quota: '定额规则',
        nothing: '【无】'
      }
    },
    // 回收站
    recycleBin: {
      reduction: '还原',
      delete: '彻底删除',
      deleteAll: '清空回收站',
      emptyText: '没有文件',
      reductionDialog: {
        title: '请选择文件',
        success: '还原成功',
        fail: '还原失败'
      },
      deleteAllDialog: {
        title: '确定要清空回收站吗？',
        desc: '清空回收站后，不能恢复',
        confirm: '确定清空',
        noPower: '无清空回收站权限！请联系项目创建人!',
        nothing: '没有可清空的文件',
        success: '清空回收站成功',
        fail: '清空回收站失败'
      },
      deleteDialog: {
        title: '确定要彻底删除吗？',
        desc: '文件彻底删除后，不能恢复',
        noPower: '无彻底删除权限！请联系项目创建人!',
        confirm: '确定删除',
        success: '删除成功',
        fail: '删除失败'
      }
    },
    pageIndex: {
      intro: '了解造价云',
      active: {
        title: '真正贴合实际使用场景的造价云',
        one: {
          scene: '场景一 【办公室】',
          firstRole: '造价员',
          firstRoleDesc: '工程及造价数据便捷上传，企业及个人数据快速复用进行组价，快速形成优质造价方案，时间大节省，质量大提升。',
          secondRole: '主管',
          secondRoleDesc1: '所有工程集中云端存储与管理，阿里云保障网银级加密,比硬盘更安全，比硬盘更便宜，免去硬盘存储的大花销。',
          secondRoleDesc2: '数据快速积累与审核，造价工程无锁便捷预览。',
          secondRoleDesc3: '优质造价方案为招投标助力，时间质量双提升，提高企业竞争力。'
        },
        two: {
          scene: '场景二 【在家中】',
          firstRole: '员工',
          firstRoleDesc: '回家后计价算量软件直接打开云端工程，进行工程编辑后自动同步，再也不需要U盘拷来拷去，再也不会出现文件混乱的情况。',
          secondRole: '领导',
          secondRoleDesc1: '网页上快速预览造价工程，无需插锁，无需安装软件。',
          secondRoleDesc2: '手机上快速预览造价工程，进行审核和批注。'
        },
        three: {
          scene: '场景三 【在工地】',
          firstRole: '员工一',
          firstRoleDesc: '打开手机直接查看造价工程文件，进行批注，回去后再行修改。',
          secondRole: '员工二',
          secondRoleDesc1: '手机查看咨询，最新政府文件最快了解。',
          secondRoleDesc2: '老板，同事想了解工程造价？手机查看，一键分享。'
        }
      },
      ad: '立即使用造价云，开启轻松工作',
      tel: '4000-166-166'
    },
    // 登录
    login: {
      title: '欢迎使用造价云管理平台',
      userName: '手机、邮箱、用户名',
      validateEmpty: '请输入用户名和密码',
      validateRules: '请输入正确邮箱账号', // 需提供文案
      password: '请输入您的密码',
      forget: '忘记密码？',
      send: '立即登录',
      fail: '登录失败',
      register: '注册广联达账号',
      space: '个人空间容量',
      enter: '进入造价云管理平台',
      logout: '退出',
      loginAgain: '当前用户已失效，请重新登录',
      registerLink: 'https://account.glodon.com/register',
      forgetLink: 'https://account.glodon.com/forgetInit',
      logoutConfirm: '该操作将会导致中断正在上传的任务，您是否确定?',
      logoutFail: '账号系统登出失败'
    },
    // 导航栏
    header: {
      welcome: '您好',
      admin: '我是管理员',
      productCenter: '产品中心',
      user: {
        enterpriseLink: 'https://account.glodon.com/enterprise',
        securityLink: 'https://account.glodon.com/security/emailbind',
        space: '个人空间容量',
        userCenter: '用户中心',
        safeCenter: '安全中心',
        help: '帮助文档',
        history: '历史上传',
        logout: '退出'
      }
    },
    // 上传
    upload: {
      tooMore: '文件过多，一次最多可以上传100个文件',
      limitSize: '单个文件不能超过500MB，请您选择小于500MB的文件上传',
      buySpace: '企业共享空间容量不足，请您联系本地销售人员购买容量套餐',
      spaceSizeValidate: '个人空间容量不足，请您整理个人空间',
      expanded: '企业共享空间容量不足，请您联系管理员进行扩容',
      cancelUpload: '确定要取消该上传吗？',
      title: '文件及数据上传中',
      name: '工程文件',
      dataFile: '数据文件',
      size: '大小',
      status: '状态',
      uploading: '上传中',
      uploadFinish: '上传完成',
      uploadSuccess: '上传成功',
      uploadFail: '上传失败',
      confirmDialog: {
        title: '存在一个或多个文件重名，是否替换？',
        confirm: '替换',
        add: '追加',
        cancel: '跳过'
      },
      closeDialog: {
        width: 340,
        title: '关闭上传列表后，上传中的工程可在历史上传中查看',
        desc: '不再提示'
      },
      errorTipsTitle: '不支持此类工程文件导入',
      errorTipsValidate: '不支持此类工程文件导入，支持的范围为：08，13清单，后缀名为GBQ5，GPB5，GPV5，GSC5，GSH5，GBQ6，GPB6，GPV6，GSC6，GSH6的工程',
      buy: '购买套餐'
    },
    // 历史上传
    uploadRecord: {
      back: '返回主页',
      uploading: '上传中',
      uploaded: '已上传',
      engineeringRecord: '工程上传记录',
      column: {
        name: '名称',
        uploadTime: '上传时间',
        size: '文件大小',
        status: '上传状态',
        desc: '上传说明'
      },
      notEngineeringRecord: '还没有工程上传记录',
      notItemRecord: '还没有清单上传记录',
      notGroupRecord: '还没有组件上传记录',
      serviceError: '服务器异常'
    },
    pagination: {},
    container: {
      recycle: {

      },
      upload: '上传',
      uploadFile: '上传文件',
      uploadFolder: '上传文件夹',
      addFolder: '新建文件夹',
      refresh: '刷新',
      download: '下载',
      downloading: '正在下载文件',
      downloadingCloudFiles: '正在下载云文件',
      uploadingData: '正在上传数据',
      uploadingFiles: '正在上传文件',
      operating: '正在处理',
      browserValidate: '当前浏览器不支持模型查看，请您使用Google浏览器查看模型。',
      downloadChrome: '下载Google浏览器',
      downloadFail: '下载失败',
      noPowerToDownload: '您没有企业空间权限，请联系管理员获取权限。',
      adminAccount: '管理员账号为: {0}',
      someNeedPower: '部分工程需要企业空间权限，请联系管理员获取权限。',
      copyToCompanySuccess: '已成功复制到共享空间',
      copyToCompanyFail: '复制到企业空间失败',
      folderIsEmpty: '文件夹是空',
      exchange: '转存到我的空间',
      copyToCompanySpace: '复制到共享空间',
      drag: '可将文件拖拽到框内任意区域',
      report: '多工程报表',
      xtModel: '协同建模',
      createProject: '创建项目',
      cancelPower: '取消权限',
      addPower: '开通权限',
      export: '导出',
      excelExport: 'excel导出',
      interfaceExport: '平台接口导出',
      delete: '删除',
      move: '移动到',
      preview: '预览',
      model: '查看模型',
      modelTitle: '工程浏览',
      share: '分享',
      rename: '重命名',
      editFail: '修改失败！',
      sort: '排序',
      engineeringName: '工程名称',
      confirmText: '确定',
      confirmDeleteText: '确定删除',
      cancelText: '取消',
      queryFail: '获取数据失败',
      saveSuccess: '保存成功',
      saveFail: '保存失败',
      operateFail: '系统文件夹，不支持操作',
      folderAlreadyExist: '文件夹已存在',
      addFolderFail: '创建文件夹失败！',
      fileNameEmpty: '文件名不能为空',
      fileNameValidate: '文件名不能包含下列任何字符：\\ / : * ? " < > $ |  并且不能以 . 开头和结尾',
      fileNameTooLong: '文件名字长度应该不超过83个字符长度',
      deleteDialog: {
        title: '确定要把文件删除？',
        tips: '删除将无法找回',
        desc: '删除文件可以通过“回收站”来还原',
        success: '删除成功',
        fail: '删除失败'
      },
      moveDialog: {
        moveFiles: '移动文件',
        space: '我的空间',
        moving: '正在移动文',
        movingFiles: '正在移动文件',
        success: '移动成功',
        fail: '移动失败'
      },
      shareDialog: {
        expiryDate: '链接有效期',
        oneDay: '1天',
        sevenDay: '7天',
        longTime: '永久',
        effective1: '1天有效',
        effective7: '7天有效',
        effectiveLong: '永久有效',
        confirm: '创建链接',
        time: '时间',
        copy: '复制链接',
        success: '分享成功',
        fail: '分享失败，请稍后再试',
        copySuccess: '链接已复制，您可以打开qq、微信等工具进行粘贴并分享工程!',
        copyFail: '该浏览器不支持自动复制!'
      },
      copyDialog: {
        tips: '确定要把文件复制到共享空间吗？',
        tipsRed: '为了避免长时间等待，请每次操作少量文件'
      },
      allFiles: '全部文件',
      valuationDoc: '计价文件',
      meteringDoc: '计量文件',
      comeBack: '返回上级',
      search: {
        placeholder: '请输入名称',
        button: '搜索'
      },
      column: {
        selectAll: '全选',
        selected: '已选中 {number} 个文件/文件夹',
        name: '名称',
        type: '类型',
        region: '地区',
        updateTime: '更新时间',
        editTime: '修改时间',
        createTime: '创建时间',
        size: '文件大小',
        shareTime: '分享时间',
        remainingTime: '剩余时间',
        sharePerson: '分享人',
        failure: '已失效',
        valuation: '计价',
        metering: '计量',
        meteringXT: '计量协同'
      },
      emptyText: '还没有上传文件',
      receive: {
        emptyText: '还没有收到工程文件'
      },
      operateTip: {
        other: '其他',
        operateFile: '当前文件或文件夹正在被<em style="color: #1c6ccd;">{0}</em>账号操作，为避免编辑的内容被相互覆盖或文件丢失，暂不可进行此操作，请稍后重试。',
        operateParentFile: '当前文件或文件夹的父文件夹（<em style="color: #1c6ccd;">{0}</em>）正在被<em style="color: #1c6ccd;">{1}</em>账号操作，为避免编辑的内容被相互覆盖，暂不可进行此操作，请稍后重试。',
        operateChildFile: '当前文件夹下的文件或者文件夹（<em style="color: #1c6ccd;">{0}</em>）正在被<em style="color: #1c6ccd;">{1}</em>账号操作，为避免文件丢失，暂不可进行此操作，请稍后重试。'
      }
    },
    // 底部
    footer: {
      aboutLink: 'https://account.glodon.com/about',
      contactLink: 'https://account.glodon.com/contact',
      about: '关于我们',
      contact: '联系我们',
      protocol: '用户协议',
      privacy: '隐私条款',
      record: '© 1998-2020 广联达科技股份有限公司. 京ICP证010052号 京ICP备10021606号-1 京公网安备110108401054号'
    },
    // 预览
    preview: {
      toLarge: '图片大于10M，请先下载再查看!',
      parseFail: '模型解析错误',
      parsing: '正在为您解析模型',
      later: '文件上传<span class="bim_wait_date">30分钟</span>后即可查看',
      formatWarning: '暂不支持此类文件预览',
      regionWarning: '暂不支持本地区工程预览，正在开发中，敬请期待~'
    },
    // 消息
    message: {
      myNews: '我的消息',
      shareMessage: '分享消息',
      commentMessage: '批注消息',
      projectMessage: '项目消息',
      load: '消息正在加载...',
      image: '图片',
      comment: '工程有批注',
      receiveLink: '我收到分享链接',
      noMessage: '您当前还没有收到消息哦~',
      loadFail: '加载消息失败！',
      openMessageCenter: '打开消息中心',
      day: '天',
      hours: '小时',
      expiryDate: '剩余有效期',
      messageCenter: '消息中心',
      allShare: '全部分享',
      myShare: '我分享的消息',
      shareToMe: '分享给我的消息',
      mark: '标记为已读',
      markAll: '全部标记为已读',
      selectNone: '未选中任何通知',
      tips: '确定要把通知删除？',
      tipsRed: '删除将无法找回！',
      shareByMeLongWord: '我分享了 <span class="blue">{0}</span>， 生成了分享链接： <span class="blue">{1}</span>',
      shareWithMeLongWord: '收到 <span class="blue">{0}</span> 分享的 <span class="blue">{1}</span>',
      MyReceiveLink: '我收到分享链接: <span class="blue">{0}</span>',
      shareToOthers: '我分享给 <span class="blue">{0}</span>, <span class="blue">{1}</span>',
      openFile: '打开文件',
      back: '返回平台',
      alreadyDelete: '分享工程已被删除',
      alreadyFailure: '分享工程已失效'
    },
    workbench: {}
  }
}
export default lang
